import api from '../plugins/api.js';
import dayjs from 'dayjs';
var localizedFormat = require('dayjs/plugin/localizedFormat');
dayjs.extend(localizedFormat);

const store = {
    namespaced: true,
    state: {
        notifications: [],
        urgentNotifications: [],
        listedNotifications: [],
        unreadNotificationCount: 0,
        notificationsContainerOpened: false,
    },
    actions: {
        /**
         * @param context - Vuex context
         * @param {Object} notification
         * @param {string} notification.message - Notification text
         * @param {"info"|"success"|"error"} notification.type - Different styling based on type
         * @param {number} notification.timeout - How long should notification stay visible
         */
        show({ commit }, notification) {
            commit('addNotification', {
                id: Date.now(),
                type: notification.type ?? 'info',
                message: notification.message,
                timeout: notification.timeout ?? 3000,
            });
        },
        hide({ commit }, notificationId) {
            commit('removeNotification', notificationId);
        },
        getUrgentNotifications({ commit }) {
            const queryParams = {
                'filter[type]': 'App\\Notifications\\Reminder',
                'filter[isRead]': 0,
            };

            api.get('notifications', { params: queryParams }).then((res) => {
                if (res.data.data.length === 0) {
                    return;
                }

                const urgentNotifications = res.data.data;
                commit('saveUrgentNotifications', urgentNotifications);
            });
        },
        getNotifications({ commit }) {
            const queryParams = {
                sort: '-createdAt',
                'page[size]': 5, // 5 notifications
                'filter[type]': 'App\\Notifications\\Dashboard',
            };

            return api.get('notifications', { params: queryParams }).then((res) => {
                if (res.data.data.length === 0) {
                    return;
                }

                const notifications = res.data.data;

                commit('saveNotifications', notifications);
                commit('saveUnreadNotificationCount', res.data.meta.unread);
            });
        },
        markAllNotificationsAsRead({ state, dispatch }) {
            const data = state.listedNotifications.map(() => {
                return {
                    attributes: {
                        isRead: 1,
                    },
                };
            });
            return api
                .patch('notifications/all', {
                    is_read: true,
                })
                .then((res) => {
                    dispatch('getNotifications');
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        markNotificationAsRead({ dispatch }, notificationId) {
            return api
                .patch(`notifications/${notificationId}`, {
                    data: {
                        type: 'notifications',
                        id: notificationId,
                        attributes: {
                            isRead: true,
                        },
                    },
                })
                .then((res) => {
                    dispatch('getNotifications');
                })
                .catch((e) => {
                    console.log(e);
                });
        },
    },
    mutations: {
        addNotification(state, notification) {
            state.notifications.push(notification);
        },
        removeNotification(state, notificationId) {
            const index = state.notifications.findIndex((not) => not.id === notificationId);
            state.notifications.splice(index, 1);
        },
        handleNotificationsContainerOpened(state) {
            state.notificationsContainerOpened = !state.notificationsContainerOpened;
        },
        saveUrgentNotifications(state, urgentNotifications) {
            state.urgentNotifications = urgentNotifications.map((notification) => ({ id: notification.id, title: notification.attributes.title }));
        },
        saveNotifications(state, allNotifications) {
            let notifications = [];
            allNotifications.forEach((notification) => {
                notifications.push({
                    id: notification.id,
                    title: notification.attributes.title,
                    message: notification.attributes.message,
                    buttonPrimary: notification.attributes.buttonPrimary,
                    buttonPrimaryAction: notification.attributes.buttonPrimaryAction,
                    buttonSecondary: notification.attributes.buttonSecondary,
                    buttonSecondaryAction: notification.attributes.buttonSecondaryAction,
                    type: notification.attributes.type,
                    isRead: notification.attributes.isRead,
                    createdAt: dayjs(notification.attributes.createdAt).format('LL') + ' at ' + dayjs(notification.attributes.createdAt).format('LT'),
                    updatedAt: dayjs(notification.attributes.updatedAt).format('LL') + ' at ' + dayjs(notification.attributes.createdAt).format('LT'),
                    links: notification.links.self,
                });
            });
            state.listedNotifications = notifications;
        },
        saveUnreadNotificationCount(state, data) {
            state.unreadNotificationCount = data;
        },
    },
};
export default store;
